import "../../MissionAndVission/MissionContact/MissionContact.css";
import "./EWLastBanner.css";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Modal from "../../../Pages/ModalForm";

const EWLastBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  return (
    <>
      <div className="mission-contact ew-lastbanner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="headings contact-h1 text-white">
                <span className="contact-h1-span">Ready to</span> Explore the
                World of Travel Excellence{" "}
                <span className="text-white" style={{ fontWeight: "bold" }}>
                  ?
                </span>
              </h1>
              <p className="mission-contact-p">
                Reach out to us for details on our exclusive events and
                webinars. Share your info, and let’s connect!
              </p>
              <div className="carouselCaption">
                {/* <a href="/contact"> */}
                <button
                  className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold"
                  type="submit"
                  onClick={handleShow}
                >
                  GET IN TOUCH
                </button>
                {/* </a> */}
              </div>
              <Modal show={showModal} handleClose={handleClose} />
            </div>
            <div className="col-lg-6">
              <div className="contact-image-m">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/EWlastbanner.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EWLastBanner;
